module.exports = __webpack_public_path__ + "img/OverseaMember16.cdcc56b0.jpg";